
define('text!templates/modules/setting/business/payment/payment-method-form.html',[],function () { return '<div class="payment-method-input"></div>\n<div class="payment-paypal-message">{{#t}}payment:paypal_message{{/t}}</div>\n<div class="payment-credit-card-message">{{#t}}payment:credit_card_message{{/t}}</div>\n';});

